import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full" }
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }

import {onMounted} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {ErrorLocationType, PreferenceType} from "@/utilities/enums/Enums";
import {UserPreference} from "@/models/user/UserPreference";
import {$t, i18n} from "@/utilities/i18n/config";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {GeneralResponse} from "@/models/api/Responses";
import jwt_decode from "jwt-decode";
import router from "@/router";
import {notify} from "@kyvg/vue3-notification";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {UserService} from "@/utilities/services/entities/UserService";
import {MiscService} from "@/utilities/services/entities/MiscService";
import {usePermissionStore} from "@/stores/PermissionStore";
import {anabPolicies} from "@/AppConfig";
import {PermissionService} from "@/utilities/services/PermissionService";



export default /*@__PURE__*/_defineComponent({
  __name: 'SamlCallback',
  setup(__props) {

const globalStore = useGlobalStore();
const userService = new UserService();
const miscService = new MiscService();
const permissionService = new PermissionService();

const setUserSettings = async(userId:string)=> {
  // get filters for user
  const filterResp = await userService.getUserPreferences(userId, PreferenceType.filter);
  // get hiddenColumns for User
  const columnResp = await userService.getUserPreferences(userId, PreferenceType.hiddenColumn);
  // get general settings for User
  const genSetResp = await userService.getUserPreferences(userId, PreferenceType.general);
  // get columnOrder settings for User
  const colOrderResp = await userService.getUserPreferences(userId, PreferenceType.columnOrder);

  if (filterResp?.statusCode === 0 && columnResp?.statusCode === 0 && genSetResp?.statusCode === 0 && colOrderResp?.statusCode === 0) {
    globalStore.setUserPreferences({
      userFilters: filterResp.preferenceInfo ?? [],
      userHiddenColumns: columnResp.preferenceInfo ?? [],
      userColumnOrder: colOrderResp.preferenceInfo ?? [],
      general: {
        darkMode: genSetResp.preferenceInfo.find((pi: UserPreference) => pi.attributeName === "darkMode")?.attributeValue ?? false,
        userStartPage: genSetResp.preferenceInfo.find((pi: UserPreference) => pi.attributeName === "userStartPage")?.attributeValue ?? "/account",
        userLocale: genSetResp.preferenceInfo.find((pi: UserPreference) => pi.attributeName === "userLocale")?.attributeValue ?? "de",
      },
    });

    // set language. if not null or undefined fallback to DE
    // @ts-expect-error
    i18n.global.locale.value = globalStore.userPreferences.general.userLocale;
  } else {
    ErrorHandler.handleError(new GeneralResponse(6666, "Ihre Einstellungen konnten nicht geladen werden"), ErrorLocationType.table);
  }
}

const setHubNotifs = async()=>{
  const notifResp = await miscService.getHubNotifications();

  if(notifResp?.statusCode === 0){
    globalStore.notifications = notifResp.notifications;
  }
  else{
    ErrorHandler.handleError(
        new GeneralResponse(6667, "Die Benachrichtigungen konnte nicht geladen werden"),
        ErrorLocationType.table
    );
  }
}

const addDynamicRoles= async ()=>{
  const readRoleString = globalStore.settings.disdiSettings?.permissionRead.join(", ");
  const editRoleString = globalStore.settings.disdiSettings?.permissionEdit.join(", ");

  //TODO magic string? better idea?
  permissionService.updateDynamicPolicy("Disdi.Read", readRoleString as string);
  permissionService.updateDynamicPolicy("Disdi.LocationPropertyEdit", editRoleString as string);
}

onMounted(async ()=> {
  const samlMadeToken = localStorage.getItem("XSamlToken") as string; // null check?

  globalStore.setToken(samlMadeToken);

  localStorage.removeItem("XSamlToken");


  //@ts-expect-error
  const userInfo = await userService.getUserById(jwt_decode(samlMadeToken).sub ?? jwt_decode(samlMadeToken).id);

  if (userInfo === null) {
    console.error("couldn't get user -> api resopnded with error");
    return;
  }

  globalStore.setUser(userInfo);

  await setUserSettings(userInfo.id);
  await setHubNotifs();

  // set new fully set policy array on permission store to make sure it survives page reloads
  const permissionStore = usePermissionStore();
  permissionStore.anabPolicies = anabPolicies;

  await addDynamicRoles();

  //@ts-expect-error
  await router.push(globalStore.userPreferences.general.userStartPage);

  notify({
    title: "Erfolg",
    text: $t('login.notifySuccessfulLogin'),
    duration: 5000,
    type: "success"
  });

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LoadingSpinner)
    ])
  ]))
}
}

})